import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dr-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss']
})
export class InputTextComponent implements OnInit {

  public some: string;

  constructor() { }

  ngOnInit() {
  }

}
